import baby from 'assets/images/baby.png';
import sneezingFace from 'assets/images/sneezing-face.png';
import construction from 'assets/images/construction.png';
import dogFace from 'assets/images/dog-face.png';
import woman from 'assets/images/woman.png';
import leafFlutteringInWind from 'assets/images/leaf-fluttering-in-wind.png';
import explodingHead from 'assets/images/exploding-head.png';

const heroFilterStatic = [
  {
    title: '',
    animateLetter: 'Critter Cuddler.',
    color: '#F42D53',
    image: {
      src: dogFace,
      alt: 'dog face',
    },
  },
  {
    title: '',
    animateLetter: 'Home Wrecker.',
    color: '#F27E0F',
    image: {
      src: construction,
      alt: 'Construction',
    },
  },
  {
    title: '',
    animateLetter: 'Basic Breather.',
    color: '#3E4649',
    image: {
      src: leafFlutteringInWind,
      alt: 'Leaf fluttering in wind',
    },
  },
  {
    title: '',
    animateLetter: 'Big Sneeze.',
    color: '#FFC140',
    image: {
      src: sneezingFace,
      alt: 'Sneezing face',
    },
  },
  {
    title: '',
    animateLetter: 'Overreactor.',
    color: '#0A56EA',
    image: {
      src: explodingHead,
      alt: 'Exploding head',
    },
  },
  {
    title: '',
    animateLetter: 'Mama-to-Be.',
    color: '#1CE4D5',
    image: {
      src: woman,
      alt: 'woman',
    },
  },
  {
    title: '',
    animateLetter: 'Rookie Parent.',
    color: '#8852F6',
    image: {
      src: baby,
      alt: 'baby',
    },
  },
];

export default heroFilterStatic;
